<template>
  <el-dialog :visible.sync="visible" :title="学期争章" :close-on-click-modal="false" :close-on-press-escape="false" width="80%">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <div style="display: flex; align-items: center;">
      <el-form-item label="学期" prop="termId">
        <el-select v-model="dataForm.termId" placeholder="学期" clearable>
          <el-option v-for="termList in termList" :value="termList.id" :label="termList.termName" :key="termList.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="年级" prop="gradeId">
        <el-select v-model="dataForm.gradeId" placeholder="年级" clearable @change="getClassList()">
          <el-option v-for="grade in grades" :value="grade.gradeId" :label="grade.gradeName" :key="grade.gradeId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="班级" prop="classId">
        <el-select v-model="dataForm.classId" placeholder="班级" @change="beforeQuery()">
          <el-option v-for="classes in classList" :value="classes.id" :label="classes.className" :key="classes.id"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="beforeQuery()">查询</el-button>
        </el-form-item>
      </div>
      <el-form-item prop="classId">
        <div style="align-items: center;justify-content: left">
            <el-button style="margin-right: 10px"
                       v-for="type in typeList"
                       :key="type.id"
                       :type="type.id === typeId ?'success':'info'"
                       v-model="typeId"
                       @click="changeType(type)">{{type.typeName}}</el-button>
          </div>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
      <el-table-column prop="setNum" label="座号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="className" label="班级" header-align="center" align="center"></el-table-column>
      <el-table-column prop="studentName" label="学生姓名" header-align="center" align="center"></el-table-column>
      <el-table-column :label="decoration.taskName" v-for="decoration in gradeDecorationList" :key="decoration.taskId" header-align="center" align="center">
        <template slot-scope="scope">
          <span style="padding-right:10px;" :key="g" v-for="g in scope.row.studentDecorationList" v-if="g.decorationId === decoration.taskId">{{g.doneTaskNum}}/{{g.decorationTaskNum}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="termTableStudentDetailHandle(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle">
    </el-pagination>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
    <term-table-student-detail v-if="TermTableStudentDetailVisible" ref="termTableStudentDetail" @refreshDataList="init"></term-table-student-detail>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

import debounce from 'lodash/debounce'
import TermTableStudentDetail from './termtable-student-detail'
export default {
  components: { TermTableStudentDetail },
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/decoration/studentTermTable/page',
        getDataListIsPage: true,
        exportURL: '/decoration/termTable/export',
        deleteURL: '/decoration/termTable',
        deleteIsBatch: true,
        createdIsNeed: false,
        activatedIsNeed: false
      },
      TermTableStudentDetailVisible: false,
      visible: false,
      termList: [],
      typeId: '',
      typeList: [
        {
          id: 1,
          typeName: '基础章'
        },
        {
          id: 2,
          typeName: '特色章'
        },
        {
          id: 3,
          typeName: '星级章'
        }
      ],
      grades: [],
      classList: [],
      decorationTypeList: [],
      gradeDecorationList: [],
      dataForm: {
        termId: '',
        gradeId: '',
        classId: '',
        decorationTypeId: '',
        termTableId: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        termId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        openingObjectGroup: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.typeId = this.typeList[0].id
      this.getTermList()
      this.getGradeList()
      this.getDecorationTypeList()
    },
    beforeQuery () {
      if (this.dataForm.gradeId !== '' && this.dataForm.classId !== '') {
        this.getThisGradeDecoration()
        this.query()
      }
    },
    // 获取年段列表
    getGradeList () {
      this.$http.get(`/decoration/termgrade/getByTermTableId?termTableId=${this.dataForm.termTableId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.grades = res.data
      })
    },
    getThisGradeDecoration () {
      this.$http.get('decoration/taskTermGrade/getList', {
        params: {
          gradeId: this.dataForm.gradeId,
          termId: this.dataForm.termId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.gradeDecorationList = res.data
      })
    },
    getClassList () {
      this.dataForm.classId = ''
      this.$http.get('classmanage/classmanage/getClassListByGradeId', {
        params: {
          gradeId: this.dataForm.gradeId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.classList = res.data
      })
    },
    getTermList () {
      this.$http.get('/term/term/getTermList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.termList = res.data
      }).catch(() => {})
    },
    getDecorationTypeList () {
      this.$http.get('decoration/decorationType/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.decorationTypeList = res.data
        if (res.data.length > 0) {
          this.dataForm.decorationTypeId = res.data[0].id
        }
      })
    },
    changeType (type) {
      console.log(type)
      this.typeId = type.id
      this.query()
    },
    // changeDecorationType (type) {
    //   console.log(type)
    //   this.dataForm.decorationTypeId = type.id
    //   this.query()
    // },
    // 获取信息
    getInfo () {
      this.$http.get('/decoration/termtable/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    termTableStudentDetailHandle (row) {
      this.TermTableStudentDetailVisible = true
      this.$nextTick(() => {
        this.$refs.termTableStudentDetail.dataForm.termId = this.dataForm.termId
        this.$refs.termTableStudentDetail.dataForm.studentId = row.studentId
        this.$refs.termTableStudentDetail.dataForm.studentName = row.studentName
        this.$refs.termTableStudentDetail.init()
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.termName = this.termList.filter((e) => { return e.id === this.dataForm.termId })[0].termName
        this.$http[!this.dataForm.id ? 'post' : 'put']('/decoration/termTable/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
